export function UPDATE_USER_INFO(state, data) {
  state.userInfo = data;
}
export function UPDATE_ACTIVE_MENU(state, data) {
  state.activeMenu = data;
}
export function UPDATE_USER_COUPON(state, data) {
  state.userCouponInfo = data;
}

export function CLEAR_VUEX(state) {
  state.userInfo = null; // 用户信息
  state.activeMenu = null; // 用户选择的菜单项
  state.userCouponInfo = null; // 用户选择的优惠券
  localStorage.removeItem('yinyi_token'); // 登录标记
}
